import { TranslateOptions } from 'i18n-js'
import { FlagCountryCode } from '@lacedltd/laced-components'

export type TranslationHelper = <T = string>(
  key: string,
  options?: TranslateOptions
) => string | T

export interface LocaleProps {
  t: TranslationHelper
  locale: LacedAvailableLocales
  currency: LacedAvailableCurrencies
  location: Location
  availableLocales: LacedAvailableLocales[]
  availableCurrencies: LacedAvailableCurrencies[]
  translations: unknown
}

export type DefaultDeliveryLocations = 'GB' | 'FR' | 'DE'

export const AVAILABLE_LOCALES = ['en', 'fr', 'de'] as const

export type LacedAvailableLocales = (typeof AVAILABLE_LOCALES)[number]

export const AVAILABLE_CURRENCIES = ['GBP', 'USD', 'EUR', 'AED'] as const

export type LacedAvailableCurrencies = (typeof AVAILABLE_CURRENCIES)[number]

export type LacedAvailableLocations = FlagCountryCode

export interface Locale {
  language: string
  deliveryCountry: DefaultDeliveryLocations
}

export interface Currency {
  name: string
  symbol: string
}

export type CurrencyObject = {
  [key in LacedAvailableCurrencies]: Currency
}

export type LocaleObject = {
  [key in LacedAvailableLocales]: Locale
}

export type Location = {
  name: string
  code: LacedAvailableLocations
}

export interface LocaliseUrlOptions {
  locale?: LacedAvailableLocales
  localeAsParam: boolean
}
